import { Box, Typography } from '@mui/material';

import { emptyChartBooks, emptyListHeadphones } from '@/images';

export const EmptyViewImageKeys = {
  books: 'books',
  headphones: 'headphones',
} as const;

const EmptyViewImageMap = {
  [EmptyViewImageKeys.books]: emptyChartBooks,
  [EmptyViewImageKeys.headphones]: emptyListHeadphones,
} as const;

export const EmptyChartView = ({
  title,
  subtitle,
  imageKey,
}: {
  title: string;
  subtitle: string;
  imageKey: keyof typeof EmptyViewImageKeys;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flex: 1,
      }}>
      <Box
        component="img"
        src={EmptyViewImageMap[imageKey]}
        alt={imageKey}
        width={128}
        height={128}
      />
      <Box sx={{ width: 320 }}>
        <Typography variant="h4" sx={{ color: 'text.main', mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body3SemiBold" sx={{ color: 'text.light' }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};
